import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyZebraMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#fff" />
      {Array.from({ length: 24 }).map((_, i) => (
        <rect key={i} x={i * 33} y={0} width={18} height={1123} fill={i % 2 === 0 ? "#000" : "#fff"} />
      ))}
      <g className="mode-copy" transform="translate(48,840)" fill="#000"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyZebraMode;
